<template>
    <div class="form-info">
        <el-form :model="devcBrand" :rules="dispBrandRules" :label-position="'left'" ref="devcBrandInfo">
            <div class="form-row">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name">
                        <el-input v-model="devcBrand.name" placeholder="请输入名称"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label class="required">编码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="code">
                        <el-input v-model="devcBrand.code" placeholder="请输入编码"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
    </div>
</template>


<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-devc-brand-save',
        desc: '',
        props: ["id"],
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            let checkCode = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            return {
                devcBrand: {},
                dispBrandRules: {
                    name: [{validator: checkNull, trigger: 'blur'}],
                    code: [{validator: checkCode, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            let self = this;
            if(!Utils.isNoB(self.id)) {
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                shopDevcApi.getDevcBrandById(postData, function (result) {
                    theLoad.hide();
                    if(result.type === 'info') {
                        self.devcBrand = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        },
        methods: {
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['devcBrandInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.devcBrand;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
            ,
        },
    }
</script>





// WEBPACK FOOTER //
// src/compo/categ/DevcBrandSave.vue